import VadImage from "vadimages-nextjs-image-optimizer";

import css from "@/parts/ProductCard/product-card.module.scss";
import Link from "next/link";
import { additionalProductParts } from "./utils";
import { ProductFull } from "@api";

export const AdvancedProductCard = ({
  p,
  pDescription,
  mouthpiecesLabel,
}: {
  p: ProductFull;
  pDescription: string;
  mouthpiecesLabel: string;
}) => {
  const additionalCardParts = additionalProductParts(p.slug);
  const images = additionalCardParts.images ?? [
    { src: `/images/${p.thumbPath}`, width: 140, height: 205 },
  ];

  return (
    <div className="relative rounded-default bg-muted-tan text-warm-gray-copy p-8 h-full">
      <div>
        {/*
          One height per breakpoint for every image — one tile or two (Mini Air shows both
          colorways) — with w-auto letting each width follow its own aspect ratio, so cards in
          a row match. min-w-0 is the safety net: if a column ever gets narrower than a pair,
          the two pictures shrink by the same factor instead of overflowing.
        */}
        <div className="flex items-end justify-center gap-4 mb-5">
          {images.map((img) => (
            <div key={`eu-product-image-${img.src}`} className="min-w-0">
              <VadImage
                src={img.src}
                alt=""
                width={img.width}
                height={img.height}
                className="h-[205px] md:h-[105px] lg:h-[170px] xl:h-[205px] w-auto"
              />
            </div>
          ))}
        </div>

        <h5 className="font-semibold">{p.title}</h5>
        {!!additionalCardParts.capacity && (
          <p className="font-semibold text-[16px]">
            {additionalCardParts.capacity}
          </p>
        )}
        <p className="py-4 min-h-[152px]">
          {pDescription ??
            additionalCardParts.description ??
            p.shortDescription}
        </p>

        <div>
          <Link
            href={p.permalink ?? "/"}
            target="_blank"
            className={css["link"]}
          >
            View
          </Link>
        </div>

        {!!additionalCardParts.mouthpieces && (
          <div className="mt-5 text-center text-[12px]">
            {mouthpiecesLabel}
            <div className="grid grid-cols-3 w-full">
              {additionalCardParts.mouthpieces.map((m) => (
                <div key={`mouthpiece-${p.slug}-${m.label}`}>
                  <VadImage
                    src={m.imgName}
                    alt=""
                    width={m.imgWidth}
                    height={m.imgHeight}
                    className="mx-auto mb-2.5"
                  />
                  <p dangerouslySetInnerHTML={{ __html: m.label }} />
                </div>
              ))}
            </div>
          </div>
        )}

        {!!additionalCardParts.badge && (
          <div className="absolute top-6 right-6 z-50 bg-warm-gray-copy text-golden-lemon rounded-default">
            <span className="font-semibold mx-3 my-1 uppercase">
              {additionalCardParts.badge}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
